import type { FeatureCollection, Feature, LineString } from 'geojson';

export const geojson: FeatureCollection = {
    'type': 'FeatureCollection',
    'features': []
};

export const lineString: Feature<LineString> = {
    'type': 'Feature',
    'properties': {},
    'geometry': {
        'type': 'LineString',
        'coordinates': []
    }
};

export const INITIAL_DISTANCE_LABEL = '距離を計測するには、地図上をクリックしてください。';
